import { assetUrl } from '#/utils/assetUrl';
import { ctaLinkProps } from '#/domains/landing/utils/ctaLink';
import { DEEPLINK_BENEFIT_CTA } from '#/constants/deeplinks';

interface PromoBannerProps {
  title?: string;
  ctaLabel?: string;
  /** Tighter layout when there are no benefit cards above (matches generator). */
  compact?: boolean;
  href?: string;
  trackingEventKey?: string;
  /** Per-page illustration override; falls back to the shared default. */
  image?: string;
}

const DEFAULT_IMAGE = '/promo-banner-illustration.png';

export default function PromoBanner({
  title = '더 많은 맞춤 혜택 정보를 원한다면?',
  ctaLabel = '더 찾아보기',
  compact = false,
  href = DEEPLINK_BENEFIT_CTA,
  trackingEventKey,
  image = DEFAULT_IMAGE,
}: PromoBannerProps) {
  const { href: finalHref, onClick: handleCtaClick } = ctaLinkProps(
    href,
    trackingEventKey
  );
  return (
    <div
      className={`flex w-full flex-col items-center justify-end ${
        compact
          ? 'bg-white pb-16 pt-0'
          : 'bg-gradient-to-b from-transparent via-white via-[30%] to-white pb-6 pt-5'
      }`}
    >
      <div
        className={`flex w-full items-center justify-center ${compact ? 'pt-0' : 'pt-2'}`}
      >
        <div className="flex w-full max-w-[280px] flex-col items-center gap-4">
          <img
            src={assetUrl(image)}
            alt=""
            className="h-36 w-auto object-contain"
          />
          <p className="line-clamp-2 whitespace-pre-line text-center text-xl font-bold leading-[1.5] text-gray-100">
            {title}
          </p>
          <a
            id="btn-promo-cta"
            href={finalHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCtaClick}
            className="flex h-11 cursor-pointer items-center justify-center gap-1 rounded-full bg-blue-55 px-5 transition-colors active:bg-blue-50"
          >
            <span className="text-sm font-bold leading-[1.5] text-white">
              {ctaLabel}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
